import ReportIframe from './ReportIframe';

export default ReportIframe;
